// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Auth_wrapper__EzhVB","flexRow":"Auth_flexRow__3nM5P","imgDiv":"Auth_imgDiv__3VT2-","childDiv":"Auth_childDiv__3n7Iw"};